import { render, staticRenderFns } from "./ValueEdit.vue?vue&type=template&id=6563d7a4&"
import script from "./ValueEdit.vue?vue&type=script&lang=js&"
export * from "./ValueEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports